/**
 * @module cercaliagl/view/VGasStationPopup
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import $ from 'jquery';
import BaseView from './BaseView';
/**
 * @typedef {Object} GasStationInfo
 * @property {string} [id]
 * @property {import("../servers.js").GeEntity} [ge]
 * @property {string} [info]
 * @property {string} [name]
 * @property {string} [schedule]
 * @property {string} [address]
 * @property {string} [locality]
 * @property {string} [municipality]
 * @property {string} [subregion]
 * @property {string} [gas95]
 * @property {string} [gas98]
 * @property {string} [diesel]
 * @property {string} [biodiesel]
 * @property {string} [gnc]
 * @property {string} [gnl]
 * @property {string} [glp]
 * @property {boolean} [showFont]
 */
/**
 * @enum {string}
 */
export var EventType = {
    DIRECTION_TO: 'direction_to',
};
/**
 * @classdesc
 */
var VGasStationPopup = /** @class */ (function (_super) {
    __extends(VGasStationPopup, _super);
    /**
     * @constructor
     */
    function VGasStationPopup() {
        var _this = this;
        var jqElement = $('<div class="v-gasstationpopup mdc-elevation--z4"></div>');
        _this = _super.call(this, jqElement) || this;
        /**
         * @private
         * @type {import("../LonLat.js").default|undefined}
         */
        _this.position_ = undefined;
        /**
         * @private
         * @type {GasStationInfo}
         */
        _this.info_ = {};
        return _this;
    }
    /**
     * @private
     */
    VGasStationPopup.prototype.render_ = function () {
        var html = "\n    <div class=\"header\">\n      <span>".concat(this.info_.name, "</span>\n    </div>\n    <div class=\"gas-content\">\n      <div class=\"address\">\n        <p>\n        ").concat(this.info_.address ? "".concat(this.info_.address, "<br/>") : '', "\n        ").concat(this.info_.locality ? "".concat(this.info_.locality, "<br/>") : '', "\n        ").concat(this.info_.subregion ? "".concat(this.info_.subregion) : '', "\n        </p>\n      </div>\n      <div class=\"prices\">\n      ").concat(this.info_.schedule ? " \n        <div>\n          <span class=\"icon-schedule\"></span>\n          <span class=\"text\">".concat(this.info_.schedule, "</span>\n        </div>") : '', "\n        ").concat(this.info_.gas95 ? "\n        <div>\n          <span class=\"icon-gas95\"></span>\n          <span class=\"text\">".concat(this.info_.gas95, "\u20AC/l</span>\n        </div>") : '', "\n        ").concat(this.info_.gas98 ? "\n        <div>\n          <span class=\"icon-gas98\"></span>\n          <span class=\"text\">".concat(this.info_.gas98, "\u20AC/l</span>\n        </div>") : '', "\n        ").concat(this.info_.diesel ? "\n        <div>\n          <span class=\"icon-diesel\"></span>\n          <span class=\"text\">".concat(this.info_.diesel, "\u20AC/l</span>\n        </div>") : '', "\n        ").concat(this.info_.biodiesel ? "\n        <div>\n          <span class=\"icon-biodiesel\"></span>\n          <span class=\"text\">".concat(this.info_.biodiesel, "\u20AC/l</span>\n        </div>") : '', "\n        ").concat(this.info_.gnc ? "\n        <div>\n          <span class=\"icon-gnc\"></span>\n          <span class=\"text\">".concat(this.info_.gnc, "\u20AC/l</span>\n        </div>") : '', "\n        ").concat(this.info_.gnl ? "\n        <div>\n          <span class=\"icon-gnl\"></span>\n          <span class=\"text\">".concat(this.info_.gnl, "\u20AC/l</span>\n        </div>") : '', "\n        ").concat(this.info_.glp ? "\n        <div>\n          <span class=\"icon-glp\"></span>\n          <span class=\"text\">".concat(this.info_.glp, "\u20AC/l</span>\n        </div>") : '', "\n      </div>\n      ").concat(this.info_.showFont ? "\n      <div class=\"font\">\n        <span>Ministerio de Industria, Energ\u00EDa y Turismo</span>\n      </div>" : '', "\n    </div>\n    <div class=\"actions\">\n      <button type=\"button\" class=\"mdc-icon-button route\">\n        <span class=\"mdc-icon-button__icon icon-direction\"></span>\n      </button>\n      <button type=\"button\" class=\"mdc-button ok\"><span class=\"mdc-button__ripple\"></span>OK</button>\n    </div>");
        this.jqElement_
            .empty()
            .append(html);
        this.show();
        this.initialize_();
    };
    /**
     * @private
     */
    VGasStationPopup.prototype.initialize_ = function () {
        var _this = this;
        this.jqElement_.find('button.route').click(function () { return _this.emit(EventType.DIRECTION_TO, _this.position_); });
        this.jqElement_.find('button.ok').click(function () { return _this.hide(); });
    };
    /**
     * @param {import("../LonLat.js").default} position Positoin
     * @param {string} name GasStation name
     * @param {string} info GasStation Info
     */
    VGasStationPopup.prototype.update = function (position, name, info) {
        var arrInfo = info.split('|');
        this.position_ = position;
        this.info_.name = name;
        /* eslint-disable prefer-destructuring */
        this.info_.address = arrInfo[1];
        this.info_.locality = arrInfo[2];
        this.info_.municipality = arrInfo[3];
        this.info_.subregion = arrInfo[4];
        this.info_.schedule = arrInfo[6];
        this.info_.gas95 = arrInfo[8];
        this.info_.gas98 = arrInfo[13];
        this.info_.diesel = arrInfo[9];
        this.info_.biodiesel = arrInfo[11];
        this.info_.gnc = arrInfo[12];
        this.info_.gnl = arrInfo[15];
        this.info_.glp = arrInfo[17];
        this.info_.showFont = true;
        /* eslint-enable prefer-destructuring */
        this.render_();
    };
    VGasStationPopup.prototype.updateWithNaturalGasStation = function (position, name, info) {
        var arrInfo = info.split('|');
        this.position_ = position;
        this.info_.name = name;
        /* eslint-disable prefer-destructuring */
        this.info_.address = arrInfo[1];
        this.info_.name = name;
        this.info_.locality = arrInfo[2];
        this.info_.municipality = arrInfo[3];
        this.info_.subregion = arrInfo[4];
        this.info_.schedule = arrInfo[6];
        this.info_.gas95 = null;
        this.info_.gas98 = null;
        this.info_.diesel = null;
        this.info_.biodiesel = null;
        this.info_.gnc = arrInfo[8];
        this.info_.gnl = arrInfo[9];
        this.info_.glp = arrInfo[10];
        this.info_.showFont = true;
        /* eslint-enable prefer-destructuring */
        this.render_();
    };
    VGasStationPopup.prototype.updateWithElectricCharger = function (position, name, info) {
        var arrInfo = info.split('|');
        // eslint-disable-next-line prefer-destructuring
        this.info_.address = arrInfo[0];
        this.info_.name = name;
        this.info_.locality = null;
        this.info_.municipality = null;
        this.info_.subregion = null;
        this.info_.schedule = null;
        this.info_.gas95 = null;
        this.info_.gas98 = null;
        this.info_.diesel = null;
        this.info_.biodiesel = null;
        this.info_.gnc = null;
        this.info_.gnl = null;
        this.info_.glp = null;
        this.info_.showFont = false;
        this.render_();
    };
    return VGasStationPopup;
}(BaseView));
export default VGasStationPopup;
//# sourceMappingURL=VGasStationPopup.js.map